function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useState } from "react";
import PropTypes from "prop-types";
import SvgMap from "../maps";
import Button from "../button/index";

const CustomMap = ({
  maps,
  isFiltered,
  onReset,
  onChange,
  partiesWinners,
  currentCommunity,
  isRegional,
  allRegions,
  selectedPlace,
  native,
  showDots = false,
  excludedGrandParentIds
}) => {
  const _useState = useState(),
        _useState2 = _slicedToArray(_useState, 2),
        style = _useState2[0],
        setStyle = _useState2[1];

  const resetMap = () => {
    if (!isRegional) {
      setStyle(null);
    }

    onReset();
  };

  return React.createElement("div", {
    className: "mapWrapper"
  }, React.createElement(SvgMap, {
    excludedGrandParentIds: excludedGrandParentIds,
    native: native,
    className: "mapa-svg",
    viewVoxStyle: style,
    allRegions: isFiltered ? [] : allRegions,
    partiesWinners: partiesWinners,
    selectedPlace: selectedPlace,
    mapElements: maps,
    onClick: (item, svgEl, event) => onChange(item.parentId, item, true, event),
    currentCommunity: currentCommunity,
    showDots: showDots
  }));
};

CustomMap.propTypes = {
  maps: PropTypes.arrayOf(PropTypes.shape({
    svg: PropTypes.string,
    ineId: PropTypes.string,
    main: PropTypes.bool,
    name: PropTypes.string,
    parentId: PropTypes.string,
    typePlace: PropTypes.string
  })),
  mouseEnter: PropTypes.func,
  mouseLeave: PropTypes.func
};
CustomMap.defaultProps = {
  maps: null,
  partiesWinners: null
};
export default CustomMap;